import * as DataStoreClassifications from './classifications/DataStoreClassifications.selectors';

export const classifications = DataStoreClassifications;
